import styled from 'styled-components';
import { CampaignStatusStyle } from './CampaignStatus.interface';

export const Wrapper = styled.div<CampaignStatusStyle>`
    border-radius: 4px;
    line-height: 24px;
    text-align: center;
    padding: 0 ${({ theme }) => theme.spacing * 6}px;
    color: ${(props) => props.color};
    text-transform: uppercase;
    font-size: 10px;
    border: 1px solid ${(props) => props.color};
    letter-spacing: 2px;
    font-weight: 900;
    height: 24px;
    width: fit-content;
`;
